export default __webpack_public_path__ + "static/media/orderbook_navicon.214abf69.svg";